import React, { useEffect } from 'react'
import Sales from '../../context/Sales'
import { Loading, Revealable } from '@abw/badger-ui'
import { markupHTML } from '../../utils'
import { Helmet } from 'react-helmet-async'

export const FAQ = ({sales}) => {
  const loader = sales.loadFAQS;
  useEffect(
    () => {
      if (!sales.faqs) {
        loader();
      }
    },
    [loader, sales.faqs]
  );
  return sales.faqs
      ? <FAQList faqs={sales.faqs}/>
      : <Loading overlayColor="black"/>
}

const FAQList = ({faqs}) =>
  <>
    <Helmet>
      <title>LFH - Frequently Asked Questions</title>
    </Helmet>
    <div className="faqs about">
      <h1 className="mar-t-none mar-b">Frequently asked questions</h1>
      { faqs.map(
          section => <FAQSection key={section.n} section={section}/>
      )}
    </div>
  </>

const FAQSection = ({section}) =>
  <section className="faq">
    <h3 className="section-title mar-t-none"><span className="n">{section.n}</span> {section.title}</h3>
    { section.questions.map(
        question => <FAQQuestion key={question.n} question={question}/>
    )}
  </section>

const FAQQuestion = ({question}) =>
  <Revealable title={<><span className="n">{question.n}</span>{question.question}</>}>
    <div className="answer" dangerouslySetInnerHTML={{__html:markupHTML(question.answer)}}/>
  </Revealable>

export default Sales.Consumer(FAQ)